module.exports = __webpack_public_path__ + "img/baleno-glx-sonic-silver.5aaec0d3.png";